'use strict';

function SystemStatusInterfaceStatusDirective() {
  return {
    restrict: 'E',
    template: require('../templates/system-status-interface-status.html'),
    controller: 'SystemStatusInterfaceStatusController'
  };
}
SystemStatusInterfaceStatusDirective.$inject = [];
module.exports = SystemStatusInterfaceStatusDirective;